import React from 'react';

const TextInput = ({ 
  name, 
  type,
  min,
  onChange,
  placeholder,
  value,
  register,
  check = true,
  info_type,
  required = false,
}) => {
  return (
    <>
      <input 
        name={name}
        min={min}
        type={type}
        id={name}
        placeholder={placeholder}
        onChange={onChange && ((event) => onChange(event, name, info_type))}
        value={value && value}
        ref={register}
        disabled={!check ? true : false}
        required={required}
      />
    </>
  )
}

export default TextInput;